var loadedJs = [];
var queueJs = {};
var aliasJs = {
  'simplistic': '//cdn.shopify.com/s/files/1/0258/3088/3407/t/91/assets/simplistic.js?v=11309964262288329825',
  'slick': '//cdn.shopify.com/s/files/1/0258/3088/3407/t/91/assets/slick.min.js?v=10847496371297070574',
  'productJs': '//cdn.shopify.com/s/files/1/0258/3088/3407/t/91/assets/ProductJs.js?v=4415553035013910411',
  'tingle': '//cdn.shopify.com/s/files/1/0258/3088/3407/t/91/assets/tingle.min.js?v=4378427205736845647',
  'photoswipe': '//cdn.shopify.com/s/files/1/0258/3088/3407/t/91/assets/photoswipe.min.js?v=15174667539489861637',
  'apiJquery': '//cdn.shopify.com/s/assets/themes_support/api.jquery-e94e010e92e659b566dbc436fdfe5242764380e00398907a14955ba301a4749f.js'
}
var require = function(file, callback){
  if(loadedJs.indexOf(file)<0) {
    if(queueJs[file]) {
      queueJs[file].push(callback);
    } else {
      queueJs[file] = [callback];

      fileUrl = (aliasJs[file] ? aliasJs[file] : file);
      $.getScript(fileUrl, function(){
        loadedJs.push(file);

        if(queueJs[file] && queueJs[file].length > 0) {
          $.each(queueJs[file], function(k, f){
            if(f) {
              f();
            }
          });
        }
      });
    }
  } else {
    if(callback) {
      callback();
    }
  }
};